import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteEntry, listArchivedEntries, unarchiveEntry } from '../api/entries'
import type { Entry } from '../api/entries'
import { useAuthStore } from '../store/auth'
import { formatDateTime } from '../utils/dates'
import { usePageHeader } from '../hooks/usePageHeader'

export function Archive() {
  const currentUser = useAuthStore((s) => s.username)
  const [entries, setEntries] = useState<Entry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    listArchivedEntries()
      .then(setEntries)
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [])

  async function handleRestore(entry: Entry) {
    try {
      await unarchiveEntry(entry.id)
      setEntries((prev) => prev.filter((e) => e.id !== entry.id))
    } catch { /* ignore */ }
  }

  async function handleDelete(entry: Entry) {
    if (!window.confirm(`permanently delete "${entry.name || 'untitled'}"? this cannot be undone.`)) return
    try {
      await deleteEntry(entry.id)
      setEntries((prev) => prev.filter((e) => e.id !== entry.id))
    } catch { /* ignore */ }
  }

  usePageHeader(currentUser ? `~${currentUser} / archive` : 'archive')

  if (loading) return <p>loading…</p>

  return (
    <div>
      {entries.length === 0 ? (
        <p style={{ opacity: 0.5 }}>no archived entries</p>
      ) : (
        entries.map((e) => (
          <div key={e.id} style={{ borderBottom: '1px solid var(--color-fg)', padding: '0.75rem 0' }}>
            <div style={{ fontSize: '0.8rem', opacity: 0.6, marginBottom: '0.25rem' }}>
              {formatDateTime(e.created_at)}
              {e.archived_at && <> · archived {formatDateTime(e.archived_at)}</>}
            </div>
            <div style={{ marginBottom: '0.4rem' }}>
              <Link to={`/~${e.username}/entry/${e.id}`} style={{ fontWeight: 'bold' }}>
                {e.name || <em>untitled</em>}
              </Link>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', fontSize: '0.8rem' }}>
              <button type="button" onClick={() => handleRestore(e)} style={{ width: 'auto' }}>
                restore
              </button>
              <button type="button" onClick={() => handleDelete(e)} className="btn-inverse" style={{ width: 'auto' }}>
                delete permanently
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  )
}
